module.exports = __webpack_public_path__ + "static/casque2-d276b7a5a4543cd6db43d955ee4beb9a.jpg";